module.exports = __webpack_public_path__ + "img/baolaidian5.9ebe6cbf.png";